import React, { useState, useEffect } from 'react';
import { TreeSelect } from '@douyinfe/semi-ui';
import request from '../../utils/request';

const AllCategorySelector = ({ value, onChange, placeholder = '请选择分类', style = {}, excludeUid = null, typ = null }) => {
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);

    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    useEffect(() => {
        const initData = async () => {
            const data = await fetchCategories();
            const formattedData = formatTreeData(data);
            setTreeData(formattedData);

            // 检查当前选中的值是否在新的数据中存在
            if (value) {
                const checkValueExists = (items, val) => {
                    return items.some(item =>
                        item.value === val ||
                        (item.children && checkValueExists(item.children, val))
                    );
                };

                if (!checkValueExists(formattedData, value)) {
                    setSelectedValue(null);
                    if (onChange) {
                        onChange(null);
                    }
                }
            }
        };
        initData();
    }, [excludeUid, typ, value, onChange]);

    const fetchCategories = async (parentUid = '') => {
        try {
            setLoading(true);
            const response = await request.get('/go/sp/all/mlist_all_category/', {
                params: {
                    page: 0,
                    limit: 1000,
                    parent_uid: parentUid,
                    typ: !typ ? -1 : typ
                }
            });
            if (response.errno === 0) {
                return response.list || [];
            }
            return [];
        } catch (error) {
            console.error('获取分类列表失败:', error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const formatTreeData = (items) => {
        const formatted = items
            .filter(item => !excludeUid || item.uid !== excludeUid)
            .map(item => ({
                label: item.name,
                value: item.uid,
                key: item.uid,
                children: item.children ? formatTreeData(item.children) : []
            }));
        return formatted;
    };

    const loadData = async (treeNode) => {
        if (treeNode.children && treeNode.children.length > 0) {
            return;
        }
        const children = await fetchCategories(treeNode.value);
        const formattedChildren = formatTreeData(children);
        treeNode.children = formattedChildren;
        setTreeData([...treeData]);
    };

    const handleChange = (value) => {
        setSelectedValue(value);
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <TreeSelect
            style={style}
            treeData={treeData}
            value={selectedValue}
            onChange={handleChange}
            placeholder={placeholder}
            loading={loading}
            loadData={loadData}
            filterTreeNode
            showClear
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeNodeFilterProp="label"
            showSearch
            searchPlaceholder="搜索分类"
            allowClear
        />
    );
};

export default AllCategorySelector;